"use client";

import { PUBLIC_BOOKING_LIGHT_TOKENS_CLASS } from "@/app/(public)/share/booking/[orgSlug]/[eventSlug]/public-booking-floating-panel";
import { PublicBookingPhoneInput } from "@/app/(public)/share/booking/[orgSlug]/[eventSlug]/public-booking-phone-input";
import type { ReactElement } from "react";

/** Guest phone field — shared by public booking + demo-call (1:1). */
export function SchedulingGuestPhoneField({
  value,
  onChange,
  required = true,
  onValidChange,
  forceShowError = false,
}: {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly required?: boolean;
  readonly onValidChange?: (valid: boolean) => void;
  readonly forceShowError?: boolean;
}): ReactElement {
  return (
    <div className={PUBLIC_BOOKING_LIGHT_TOKENS_CLASS}>
      <label className="mb-1 block text-[12px] font-medium text-primary/55">
        Handynummer/Durchwahl{required ? " *" : ""}
      </label>
      <PublicBookingPhoneInput
        value={value}
        onChange={onChange}
        required={required}
        onValidChange={onValidChange}
        forceShowError={forceShowError}
      />
    </div>
  );
}
